module.exports = "/_next/static/images/Chicago-screenshot-1-57b8390898fa84930064c872609d7045.png";